(function () {
  'use strict';

  var rules = window.WineMinQtyRules;
  if (!rules) return;

  // ── Utilidades ────────────────────────────────────────────────

  function normalize(s) { return (s || '').trim().toLowerCase(); }

  function getMin(option1) {
    var v = normalize(option1);
    if (!v) return 0;
    var exc = rules.exceptionVariants || [];
    for (var i = 0; i < exc.length; i++) if (normalize(exc[i]) === v) return rules.exceptionMin || 4;
    var def = rules.defaultVariants || [];
    for (var j = 0; j < def.length; j++) if (normalize(def[j]) === v) return rules.defaultMin || 3;
    return 0;
  }

  function isExempt(tags) {
    var et = (rules.exemptTags || []).filter(Boolean);
    if (!et.length) return false;
    var pt = (tags || '').split(',').map(normalize).filter(Boolean);
    return et.some(function (t) { return pt.indexOf(normalize(t)) !== -1; });
  }

  function buildMsg(min) {
    return (rules.prefix || 'Compra mínima:') + ' ' + min + ' ' + (rules.suffix || 'unidades');
  }

  // ── Validación (siempre busca elementos frescos por ID) ────────

  function validateCart(itemsId, checkoutId) {
    var itemsEl = document.getElementById(itemsId);
    var btn = document.getElementById(checkoutId);
    if (!itemsEl) return;

    var hasViolation = false;
    var rows = itemsEl.querySelectorAll('[data-wine-option1]');

    rows.forEach(function (row) {
      var warnEl = row.querySelector('.wine-min-qty-warning');
      if (!warnEl) return;

      var opt = row.dataset.wineOption1 || '';
      var tags = row.dataset.wineTags || '';

      if (isExempt(tags) || getMin(opt) === 0) {
        warnEl.style.display = 'none';
        return;
      }

      var min = getMin(opt);
      var qtyInput = row.querySelector('input.quantity__input');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 0;

      if (!isNaN(qty) && qty >= min) {
        warnEl.style.display = 'none';
      } else {
        hasViolation = true;
        var span = warnEl.querySelector('span');
        if (span) span.textContent = buildMsg(min);
        warnEl.style.display = 'flex';
      }
    });

    if (!btn) return;
    if (hasViolation) {
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('data-wine-blocked', '1');
    } else if (btn.dataset.wineBlocked) {
      btn.removeAttribute('disabled');
      btn.removeAttribute('data-wine-blocked');
    }
  }

  function debounce(fn, delay) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  // ── Cart drawer ───────────────────────────────────────────────
  // cart-drawer.js reemplaza '.drawer__inner' y '#CartDrawer' con innerHTML,
  // lo que destruye #CartDrawer-CartItems en cada update. El único nodo estable
  // es el elemento <cart-drawer> que nunca se reemplaza.
  function initCartDrawer() {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl) return;

    var validate = debounce(function () {
      validateCart('CartDrawer-CartItems', 'CartDrawer-Checkout');
    }, 80);

    new MutationObserver(validate).observe(cartDrawerEl, {
      childList: true,
      subtree: true
    });

    // Validación inicial si el contenido ya está en el DOM
    validateCart('CartDrawer-CartItems', 'CartDrawer-Checkout');
  }

  // ── Cart page ─────────────────────────────────────────────────
  function initCartPage() {
    var itemsEl = document.getElementById('main-cart-items');
    if (!itemsEl) return;

    var validate = debounce(function () {
      validateCart('main-cart-items', 'checkout');
    }, 80);

    new MutationObserver(validate).observe(itemsEl, {
      childList: true,
      subtree: true
    });

    validateCart('main-cart-items', 'checkout');
  }

  // ── Init ─────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    initCartDrawer();
    initCartPage();
  });

})();
